import type { IconData } from '@stacksjs/iconify-core'

export const documentLayoutRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M11 8H3a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2m0 4H3a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2\" opacity=\".5\"/><rect width=\"8\" height=\"8\" x=\"14\" y=\"4\" fill=\"currentColor\" rx=\"1\"/><path fill=\"currentColor\" d=\"M21 16H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2m-8 4H3a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default documentLayoutRight
